import { PlusOutlined } from '@ant-design/icons';
import { Button, Typography, message } from 'antd';
import { AccessControl } from 'components/AccessControl';
import { RecordFieldWrapper } from 'components/RecordFields/style';
import { RecordInfoDrawer } from 'components/RecordInfoDrawer';
import { DELETE_ERROR, FETCH_ERROR, SUCCESS_DELETE } from 'constants/alerts';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { useDrawers } from 'hooks/useDrawers';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { useEffect, useMemo, useState } from 'react';
import { RefferersService } from 'services/web/RefferersService';
import { ActionsWrapper } from 'ui/ActionsWrapper';
import { RefsLinksForm } from './RefsLinksForm/RefsLinksForm';
import RefsLinksTable from './RefsLinksTable/RefsLinksTable';

const PAGE_TITLE = 'Реферальные ссылки';

export default function RefsLinks() {
  useDocumentTitle(PAGE_TITLE);
  useHeaderChanger(PAGE_TITLE);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchRefferals();
  }, []);

  const fetchRefferals = async () => {
    setLoading(true);

    try {
      const res = await RefferersService.getRefferers();
      setItems(res);
    } catch (err) {
      message.error(FETCH_ERROR);
    } finally {
      setLoading(false);
    }
  };

  const {
    state: { drawerVisible, formIsActive, activeRecord },
    openDrawer,
    closeDrawer,
    openCreateForm,
    openEditForm,
    closeForm,
  } = useDrawers();

  const recordFields = useMemo(() => {
    return [
      { label: 'Код', key: 'code' },
      { label: 'Наименование', key: 'title' },
    ];
  }, [activeRecord]);

  const handleDelete = async () => {
    try {
      const isDeleted = await RefferersService.deleteAppVersion(
        activeRecord?.id
      );

      if (isDeleted) {
        closeDrawer();
        message.success(SUCCESS_DELETE);
        fetchRefferals();
      }
    } catch (err) {
      message.error(DELETE_ERROR);
    }
  };

  const copyLink = () => {
    navigator.clipboard.writeText(
      `https://payda.me?refId=${activeRecord.code}`
    );
    message.success('Ссылка скопировона');
  };

  return (
    <>
      <ActionsWrapper placeEnd>
        <AccessControl pageId="refs" action="create">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={openCreateForm}
          >
            Создать
          </Button>
        </AccessControl>
      </ActionsWrapper>

      <RefsLinksTable items={items} onRowClick={openDrawer} loading={loading} />

      <RecordInfoDrawer
        record={activeRecord}
        drawerTitle={activeRecord?.title}
        recordFields={recordFields}
        isVisible={drawerVisible}
        onClose={closeDrawer}
        onEdit={openEditForm}
        pageId="refs"
        onDelete={handleDelete}
        deleteConfirmText="Вы точно хотите удалить этот реферальный код?"
      >
        <RecordFieldWrapper style={{ marginTop: '15px' }}>
          <div className="record__key">Ссылка:</div>

          <div className="record__value">
            <Typography.Link onClick={copyLink}>
              Скопировать ссылку
            </Typography.Link>
          </div>
        </RecordFieldWrapper>
      </RecordInfoDrawer>

      <RefsLinksForm
        isActive={formIsActive}
        initialValues={activeRecord}
        onSuccess={fetchRefferals}
        onClose={closeForm}
      />
    </>
  );
}
